import React, { useRef } from "react";
import { Box } from "@mui/joy";
import { useNavigate } from "react-router-dom";
import MultiTextTransition from "components/common/MultiTextTransition";
import { goal2OptionList } from "../goal/Goal_2_MultiSelect_1_Promotion";
import { goal5OptionList } from "../goal/Goal_5_Promotion";
import { useOnboardingPromotionData } from "../../../../hooks/useOnboardingPromotionData";
import { attachEulLeul } from "utils/koreanUtils";
import {
  MktVersionTypes,
  versionToPathPrefix,
} from "../../../../components/mkt/mktVersionUtils";
import { useRecoilValue } from "recoil";
import { webTestTypeAtom } from "../../../../recoil/webTestTypeAtom";

export default function Result_3_Promotion({
  version = "v4",
}: {
  version?: MktVersionTypes;
}) {
  const navigate = useNavigate();
  const webTestType = useRecoilValue(webTestTypeAtom);
  const isTherapyPromotion =
    version === "v4" && webTestType?.onboardingType === "l";

  const selectionIdListGoal2 = useOnboardingPromotionData("goal_2");
  const selectionIdListGoal5 = useOnboardingPromotionData("goal_5");

  const isMutated = useRef(false);

  const top2Goal2List = goal2OptionList
    .filter((a) => selectionIdListGoal2.multiSelectionIdList.includes(a.id))
    .sort((a, b) => a.id - b.id)
    .slice(0, 2);

  const singleGoal5 = goal5OptionList
    .filter((a) => selectionIdListGoal5.singleSelectionId === a.id && a.label)
    .slice(0, 1);

  const replacePracticeWithTreatment = (text: string) =>
    isTherapyPromotion ? text.replace(/연습을/g, "치료를") : text;

  const goal2OptionTextList = top2Goal2List.map((a, index) => {
    if (top2Goal2List.length === 1) {
      return replacePracticeWithTreatment(a.text_2);
    } else {
      // 2개
      if (index === 0) {
        return a.text_1;
      } else {
        return replacePracticeWithTreatment(a.text_2);
      }
    }
  });

  if (goal2OptionTextList.length === 0) {
    goal2OptionTextList.push(
      replacePracticeWithTreatment(
        "평안하고 여유로운 마음을 가지는\n" + "연습을 해나갈 것입니다."
      )
    );
  }

  const handleNext = () => {
    navigate(`/${versionToPathPrefix(version)}-onboarding/result/4`, {
      replace: true,
    });
  };

  const textList = [
    `데이터에 기반한\n맞춤 프로그램입니다.`,
    ...(singleGoal5.length > 0
      ? [`${attachEulLeul(singleGoal5[0].label!!)}\n집중적으로 다루며`]
      : []),
    ...goal2OptionTextList,
  ];

  return (
    <Box
      sx={{
        // 겹치는 두 개(텍스트 / 로고)를 같은 위치에 쌓아두기
        position: "relative",
        width: "100%",
      }}
    >
      <MultiTextTransition
        textList={textList}
        fadeInTime={1000}
        displayTime={2000}
        fadeOutTime={1000}
        onComplete={handleNext}
      />
    </Box>
  );
}
